import axios from './index'

function getAlarmList (req) {
  return axios.get('/alarm/list', { ...req }).then(res => {
    return {
      data: res.data.pageData,
      total: res.data.totalRecords
    }
  })
}

export default {
  getAlarmList
}
